import { HelpRequest } from '../../generated/model/models';
import { httpClient } from '../config/httpClient';

export const path = {
  helpRequest: '/help',
};

export const sendHelpRequest = async (req: HelpRequest): Promise<string> => {
  const response = await httpClient.post<string>(path.helpRequest, req);
  return response.data;
};
